import { useDataFormContext } from "../../context/data-form-context";
import {
  DataFormToolbarCancelButton,
  DataFormToolbarDeleteButton,
  DataFormToolbarEditButton,
  DataFormToolbarRefetchButton,
  DataFormToolbarSaveButton,
} from "./buttons";

type DataFormToolbarDefaultButtonsProps = {
  showCancel?: boolean;
  showSave?: boolean;

  showRefetch?: boolean;
  showEdit?: boolean;
  showDelete?: boolean;
};

export function DataFormToolbarDefaultButtons({
  showCancel = true,
  showSave = true,

  showRefetch = true,
  showEdit = true,
  showDelete = true,
}: DataFormToolbarDefaultButtonsProps) {
  const { readOnly, isEditing } = useDataFormContext();

  return (
    <>
      {isEditing ? (
        <>
          {showCancel && <DataFormToolbarCancelButton />}
          {showSave && <DataFormToolbarSaveButton />}
        </>
      ) : (
        <>
          {showRefetch && <DataFormToolbarRefetchButton />}

          {!readOnly && (
            <>
              {showEdit && <DataFormToolbarEditButton />}
              {showDelete && <DataFormToolbarDeleteButton />}
            </>
          )}
        </>
      )}
    </>
  );
}
